/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_New_List_TitleInputs */



/**
* | output |
* | --- |
* | "New Marker List" |
*
* @param {Markers_New_List_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_new_list_title = /** @type {((inputs?: Markers_New_List_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_New_List_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouvelle liste de marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Markerliste")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo elenco marcatori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новый список маркеров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nueva lista de marcadores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新标记列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいマーカーリスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नई मार्कर सूची")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nova lista de marcadores")
	return /** @type {LocalizedString} */ ("New Marker List")
});